<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			<div class="row" style="position: relative;">
				<img src="../../assets/img/fwlcBanner.png" style="width: 100%;" />
			</div>
			<div style="background-color: #f3f3f3;margin: 80px auto;min-height: 800px;width: 1000px;padding: 40px 60px;padding-bottom: 80px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					服务流程
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				
				<div class="row" style="margin-top: 60px;align-items: flex-start;">
					<div class="col-no">
						<img src="../../assets/img/fwlcImg1.png" />
						<img src="../../assets/img/fwlcImg2.png" style="margin-top: 60px;" />
						<img src="../../assets/img/fwlcImg3.png" style="margin-top: 60px;" />
						<img src="../../assets/img/fwlcImg4.png" style="margin-top: 60px;" />
					</div>
					<div class="col-no ju-c al-c" style="margin-left: 40px;">
						<div class="item-no rd"></div>
						<div class="item-no line"></div>
						<div class="item-no rd"></div>
						<div class="item-no line"></div>
						<div class="item-no rd"></div>
						<div class="item-no line"></div>
						<div class="item-no rd"></div>
						<div class="item-no line"></div>
					</div>
					<div class="col" style="margin-left: 40px;">
						<div class="row" style="font-size: 24px;color:#0599f7; font-weight: bold;">
							1.项目咨询
						</div>
						<div class="row" style="margin-top:30px;font-weight: bold;color: #666;font-size: 16px;">
							我们的哲学 : 连接人, 数据, 设备
						</div>
						<div class="row" style="margin-top:12px;color: #999;font-size: 16px;line-height: 20px;">
							前期展开工厂实际情况调研分析，根据贸宝已开发系统匹配客户工厂流程。匹配度高 : 直接试用 ; 匹配度中等 : 部分流程配置 ; 匹配度低 : 全流程定制。为达目的, 我们从规划、实施、协助等全程给到您专业的建议。
						</div>
						<div class="row" style="font-size: 24px;color:#0599f7; font-weight: bold;margin-top: 60px;">
							2.项目研发
						</div>
						<div class="row" style="margin-top:30px;font-weight: bold;color: #666;font-size: 16px;">
							近百人技术服务团队 , 产品技术高速迭代
						</div>
						<div class="row" style="margin-top:12px;color: #999;font-size: 16px;line-height: 20px;height: 82px;">
							我们由项目经理、产品经理、 UI设计师、技术研发人员所组成的团队, 全程参与所有相关部门的流程分析及讨论, 我们定义您的系统需求、开发策略及具体的实施方案，全方位保证研发进度。
						</div>
						<div class="row" style="font-size: 24px;color:#0599f7; font-weight: bold;margin-top: 60px;">
							3.系统培训
						</div>
						<div class="row" style="margin-top:30px;font-weight: bold;color: #666;font-size: 16px;">
							练习成就完美, 唯有培训合格的员工能够保障项目的成功
						</div>
						<div class="row" style="margin-top:12px;color: #999;font-size: 16px;line-height: 20px;height: 85px;">
							培训合格的员工熟练掌握系统是确保项目成功的关键, 因此我们提供了多元的培训模式, 这些课程会充分考虑受训者的职能及知识面，最终运用系统性测验考题来确保培训效果。
						</div>
						<div class="row" style="font-size: 24px;color:#0599f7; font-weight: bold;margin-top: 60px;">
							4.售后支持
						</div>
						<div class="row" style="margin-top:30px;font-weight: bold;color: #666;font-size: 16px;">
							售后支持解决用户问题, 线上10分钟内快速响应
						</div>
						<div class="row" style="margin-top:12px;color: #999;font-size: 16px;line-height: 20px;height: 81px;">
							售后支持的重要性不仅是针对问题事件, 也包括外部环境中预期的和非预期的事件如： 操作系统更新, 各相关软件更新及客户内部 IT 环境的更新等。我们以电话, 邮件, 远程、上门等方式24小时全天服务，让您售后无忧！
						</div>
					</div>
				</div>
			</div>
			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {

		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>
	.main-content {
		min-height: 100%;
		min-width: 1400px;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		/* background: #f7f7f7; */
	}

	.prduct-box {
		width: 1200px;
		/* padding-top: 60px; */
		padding-bottom: 100px;
		margin: 0 auto;
	}

	.center-body {
		margin: 0 auto;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}
	.rd{
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background-color: #0599f7;
		margin-bottom: 5px;
	}
	.line{
		width: 2px;
		height: 184.5px;
		background-color: #0599f7;
		margin-bottom: 5px;
	}
</style>
